import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        breakpoint: {
            thresholds: {
              xs: 500,
              sm: 768,
              md: 1024,
              lg: 1900,
            },
            scrollBarWidth: 8,
        },
        themes: {
            light: {
                primary: '#A6D189',
                secondary: '#525252',
                action: '#91DC60',
                error: '#F6650A',
                border: '#4CDC6E',
            }
        },
    },

});
